import { cn } from "@/utils/utils";

export default function ButtonContainer({
    children,
    className = ""
}: {
    children: any;
    className?: string;
}) {
    return (
        <div className={cn("h-full w-full flex flex-col gap-4 justify-center items-center", className)}>
            {children}
        </div>
    );
}
